<template>
  <div class="text-center">
    <v-menu
      v-model="menu"
      close-on-content-click
      :nudge-width="100"
      left
      offset-x
      attach
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          class="mx-2"
          fab
          dark
          small
          color="primary"
          v-bind="attrs"
          v-on="on"
          elevation="24"
        >
          <v-icon
            small
            dark
          >
            mdi-plus-thick
          </v-icon>
        </v-btn>
      </template>

      <v-card>
        <v-list>
          <!-- List Items -->
          <v-list-item
            v-for="(item, index) in menuItems"
            :key="index"
            @click="$emit('select', index)"
            class="list-item"
          >
            <v-list-item-content>
              <v-list-item-title class="menu-item-name">{{ item.name }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        fav: true,
        menu: false,
        message: false,
        hints: true,
        menuItems: [{ name: 'New Segment' }, { name: 'VideoAmp Audience' }, { name: 'Retargeting Request' }],
      }
    },
  }
</script>

<style lang="scss">
  .list-item:hover {
    background-color: #bbdefb;
    cursor: pointer;
  }
  .menu-item-name {
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// NewItemMenu.vue?47dfbf2e